var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconeEstetoscopio(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 53,
    viewBox: "0 0 41 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_762_217)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.8391 51.05C21.8491 51.05 17.7891 46.99 17.7891 42H17.8891C17.8891 46.93 21.9091 50.95 26.8391 50.95C31.7691 50.95 35.7891 46.93 35.7891 42H35.8891C35.8891 46.99 31.8291 51.05 26.8391 51.05Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.8398 42C38.049 42 39.8398 40.2091 39.8398 38C39.8398 35.7909 38.049 34 35.8398 34C33.6307 34 31.8398 35.7909 31.8398 38C31.8398 40.2091 33.6307 42 35.8398 42Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.45938 22H3.35938V8.00001C3.35938 5.77001 5.17938 3.95001 7.40938 3.95001V4.05001C5.22938 4.05001 3.45938 5.82001 3.45938 8.00001V22Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.418 7C12.0748 7 13.418 5.65685 13.418 4C13.418 2.34315 12.0748 1 10.418 1C8.76111 1 7.41797 2.34315 7.41797 4C7.41797 5.65685 8.76111 7 10.418 7Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.3195 22H32.2195V8.00001C32.2195 5.82001 30.4495 4.05001 28.2695 4.05001V3.95001C30.4995 3.95001 32.3195 5.77001 32.3195 8.00001V22Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.2695 7C26.9264 7 28.2695 5.65685 28.2695 4C28.2695 2.34315 26.9264 1 25.2695 1C23.6127 1 22.2695 2.34315 22.2695 4C22.2695 5.65685 23.6127 7 25.2695 7Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8398 36V39C20.8398 40.65 19.4898 42 17.8398 42C16.1898 42 14.8398 40.65 14.8398 39V36H20.8398Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.4703 22C29.7003 22 29.0003 22.45 28.6703 23.14C26.7403 27.19 22.6103 30 17.8403 30C13.0703 30 8.94031 27.19 7.01031 23.14C6.68031 22.44 5.98031 22 5.21031 22H3.01031C1.61031 22 0.61031 23.42 1.14031 24.72C3.80031 31.33 10.2803 36 17.8403 36C25.4003 36 31.8803 31.33 34.5403 24.72C35.0603 23.42 34.0703 22 32.6703 22H30.4703V22Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.3187 8.62H32.2188V13.74H32.3187V8.62Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_762_217"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40.84,
    height: 52.05,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconeEstetoscopio);
export default __webpack_public_path__ + "static/media/icone-estetoscopio.a27fc1c6b701fb541435558073bfcb0c.svg";
export { ForwardRef as ReactComponent };